module.exports = __webpack_public_path__ + "static/media/library.dcfbbfc8.png";